window.logger =
  window.IS_DEVELOPMENT || window.CONSOLE_LOG_ENABLED
    ? // window.CONSOLE_LOG_ENABLED
      console.log.bind(window.console)
    : function () {};
